<template>
    <div class="list-turma">

        <el-row :gutter="10" v-if="statusList">
            <el-col :xs="24" :sm="24" :md="24">
                <c-panel>
                    <div>

                        <div class="style-form info-turma" v-if="turma.id">
                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="12" :md="12">
                                    <dl>
                                        <dt>NOME DA TURMA</dt>
                                        <dd>
                                            {{ (turma.nome ? turma.nome : '-') }}
                                        </dd>
                                    </dl>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <dl>
                                        <dt>TURNO</dt>
                                        <dd>
                                            {{ $CONSTANTS.TURNO[turma.turno] }}
                                        </dd>
                                    </dl>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <dl>
                                        <dt>PERÍODO</dt>
                                        <dd>
                                            {{ (turma.periodo_letivo ? turma.periodo_letivo.nome : '-') }}
                                        </dd>
                                    </dl>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <dl>
                                        <dt>CURSO (S)</dt>
                                        <dd>
                                            {{ (turma.curso ? turma.curso.nome : '-') }}
                                        </dd>
                                    </dl>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="6" :md="6">
                                    <dl>
                                        <dt>LOCAL DIFERENCIADO</dt>
                                        <dd>
                                            {{ (turma.local_diferenciado == true) ? 'Sim' : ((turma.local_diferenciado == false) ? 'Não' : 'Não informado') }}
                                        </dd>
                                    </dl>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <dl>
                                        <dt>QTD. VAGAS</dt>
                                        <dd>
                                            {{ turma.qtd_vagas }}
                                        </dd>
                                    </dl>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <dl>
                                        <dt>MATRICULADOS</dt>
                                        <dd>
                                            {{ turma.matriculas.length }}
                                        </dd>
                                    </dl>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <dl>
                                        <dt>DISPONÍVEL</dt>
                                        <dd>
                                            {{ ((turma.qtd_vagas - turma.matriculas.length) > 0) ? turma.qtd_vagas - turma.matriculas.length : 0 }}
                                        </dd>
                                    </dl>
                                </el-col>
                            </el-row>
                        </div>

                        <div v-if="turma.tipo_ensino == 4" class="u-text-right">
                            <el-button @click="openDialogAlunosForReforco()" type="primary">MATRICULAR ALUNO EM ATIV. COMPLEMENTAR</el-button>
                        </div>

                        <div class="container-table u-mt-5 table-list-aluno" style="border: 1px solid #ccc; min-height: 400px;">
                            <table class="table table-striped sem-bordar-header">
                                <thead>
                                    <tr style="background-color: #35647f !important;">
                                        <th style="padding: 5px 10px; border: none; color: #fff;" colspan="100%">ALUNOS</th>
                                    </tr>
                                    <tr v-if="turma.matriculas.length > 0">
                                        <th class="hidden-mobile" style="width: 70px; border-top: none !important">MATRÍCULA</th>
                                        <th style="border-top: none !important">NOME DO ALUNO</th>
                                        <th style="border-top: none !important" class="hidden-mobile">CURSO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr @click="selectAluno(i)" v-for="(item, i) in turma.matriculas" :key="item.id" class="u-pointer">
                                        <td :style="{ backgroundColor: ((item.selected) ? '#73a9c7' : '') }" class="hidden-mobile">{{ item.num_matricula }}</td>
                                        <td :style="{ backgroundColor: ((item.selected) ? '#73a9c7' : '') }">
                                            <a @click="openDossieAluno(item.aluno.id)" title="Abrir dossiê do aluno" href="javascript:void(0)">
                                                <b class="hidden-desktop">NOME:</b> {{ (item.aluno ? item.aluno.nome : '-') }}<br>
                                            </a>
                                        <td :style="{ backgroundColor: ((item.selected) ? '#73a9c7' : '') }" class="hidden-mobile">{{ (item.curso ? item.curso.nome : '-') }}</td>
                                    </tr>
                                </tbody>
                                <tfoot v-if="turma.matriculas.length == 0">
                                    <tr style="border-top: 1px solid #ddd;">
                                        <td colspan="100%" class="u-text-center">
                                            <span>- nenhum aluno cadastrado nesta turma -</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <i class="u-ml-5 u-mt-5" style="display: block;">Selecione o aluno clicando sobre seu nome</i>

                        <div v-if="$store.state.user.tipo < 9 && turma.matriculas.length > 0" class="u-text-right">
                            <el-button @click="showDialogRemanejar()" type="info">REMANEJAR</el-button>
                        </div>

                    </div>

                </c-panel>
            </el-col>
        </el-row>

        <div v-if="!statusList" class="u-text-center u-mt-25">
            <c-panel>
                <img src="/public/img/loading-bar.gif" class="u-mt-20 u-mb-20" />
            </c-panel>
        </div>

        <el-dialog :close-on-click-modal="false" title="REMANEJAR MATRÍCULAS" :visible.sync="dialogRemanejamento">
            <div v-if="dialogRemanejamento" style="margin-top: 20px;">

                <form-remanejamento
                    :propMatriculas="matriculasSelecteds"
                    :propInstituicaoId="instituicaoSelected"
                    :propReferenciaNacional="referencia_nacional"
                    :propPeriodoLetivoId="periodoLetivoSelected"
                    :propTipoEnsino="turma.tipo_ensino"

                    v-on:onSubmitRemanejamento="emitFormRemanejamento"
                ></form-remanejamento>

            </div>
        </el-dialog>

        <!-- MODAL PARA ADICIONAR ALUNOS NA TURMA DE REFORCO OU AEE -->
        <el-dialog :close-on-click-modal="false" top="5vh" width="80%" title="ALUNOS" :visible.sync="dialogAlunosForReforco" v-on:close="closeDialogAlunosForReforco">
            <div v-if="dialogAlunosForReforco" style="margin-top: 20px;">
                <div>
                    <div class="titulo-list-instituicoes">
                        Alunos Matriculados em Turnos Opostos
                    </div>
                    <el-input class="search-alunos-reforco u-mt-10" placeholder="pesquisar.." v-model="filtroSearch" maxlength="191"></el-input>
                    <div class="list-alunos-reforco">
                        <el-checkbox-group v-model="dados.alunos" >
                        <ul>
                            <li v-for="(item, i) in alunosForReforcoFilter" :key="i">
                                <el-checkbox :label="item.id" class="checkbox-list">

                                    <div style="display: flex; justify-content: space-between; padding-right: 30px;">
                                        <span>{{ item.nome }}</span>

                                        <span>{{ item.matriculas[0].curso.nome }}/{{ item.matriculas[0].turma.nome }}</span>
                                    </div>

                                </el-checkbox>
                            </li>
                        </ul>
                        </el-checkbox-group>
                    </div>
                    <div class="u-text-right">
                        <el-button @click="onSubmitMatriculaComplementar()" type="primary">MATRICULAR</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="DOSSIÊ DO ALUNO" width="90%" top="40px" :visible.sync="dialogDossieAluno" v-on:close="closeDialogDossieAluno">
            <div v-if="dialogDossieAluno" style="margin-top: 20px;">
                <dossie-aluno :id="alunoSelected_id" v-on:changeDossie="changeDossie"></dossie-aluno>
            </div>
        </el-dialog>

    </div>
</template>
<script>

import Vue from 'vue'
import formRemanejamento from '@/components/matricula/remanejamento'
import dossieAluno from '@/components/aluno/dossie'

export default {
    props: ['paramId'],
    data: () => ({
        alunoSelected_id: '',
        dialogDossieAluno: false,
        statusList: false,
        dialogAlunosForReforco: false,
        referencia_nacional: '',
        matriculasSelecteds: [],
        instituicaoSelected: '',
        periodoLetivoSelected: '',
        dialogRemanejamento: false,
        turma: { matriculas: [] },
        alunosForReforco: [],
        alunosForReforcoFilter: [],
        filtroSearch: '',
        dados:{
            alunos: []
        }
    }),
    mounted(){

    },
    methods: {
        loadingTurma(){

            this.statusList = false;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmaWithAlunosForInfoTurmas/` + this.paramId, this.$store.getters.getHeaderAuth).then(response => {

                for(let i in response.data.matriculas){

                    Vue.set(response.data.matriculas[i], 'selected', false);
                }

                this.turma = response.data;

                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        openDossieAluno(id){

            this.dialogDossieAluno = true;
            this.alunoSelected_id = id;

        },
        closeDialogDossieAluno(){

            this.alunoSelected_id = '';
        },
        changeDossie(actions){

            if(actions.loading){

                this.loadingTurma();
            }

            if(actions.close){

                this.dialogDossieAluno = false;
            }
        },
        openDialogAlunosForReforco(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/aluno/getAlunosForReforco/${this.turma.curso.id}/${this.turma.turno}/${this.turma.instituicao_id}/${this.turma.periodo_letivo_id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.alunosForReforco = JSON.parse(JSON.stringify(response.data));
                this.alunosForReforcoFilter = JSON.parse(JSON.stringify(response.data));

                this.dialogAlunosForReforco = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitMatriculaComplementar(){

            window.eventBus.$emit('loading', true);

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/storeMatriculaComplementar/` + this.turma.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                if(typeof response.data.throw !== 'undefined'){

                    window.eventBus.$emit('throw', response.data.throw);
                    window.eventBus.$emit('loading', false);

                }else{

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.dialogAlunosForReforco = false;
                    this.loadingTurma();
                }

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        closeDialogAlunosForReforco(){

            this.alunosForReforco = [];
            this.dados.alunos = [];

        },
        showDialogRemanejar(){

            this.referencia_nacional = false;
            this.matriculasSelecteds = [];

            for(let i in this.turma.matriculas){

                if(this.turma.matriculas[i].selected){

                    if(this.referencia_nacional == false){

                        this.referencia_nacional = this.turma.matriculas[i].referencia_nacional;
                    }

                    if(this.referencia_nacional != this.turma.matriculas[i].referencia_nacional){

                        this.referencia_nacional = false;
                        window.eventBus.$emit('alert', {msg: 'Para remanejar, é necessário escolher alunos que estão cursando o mesmo curso.', type: 'warning'});
                        return false;

                    }

                    this.matriculasSelecteds.push(this.turma.matriculas[i].id);

                }
            }

            if(!this.referencia_nacional && this.turma.tipo_ensino == 1){

                window.eventBus.$emit('alert', {msg: 'Nenhum aluno selecionado.', type: 'warning'});
                return false;
            }

            this.instituicaoSelected = this.turma.matriculas[0].instituicao_id;
            this.periodoLetivoSelected = this.turma.matriculas[0].periodo_letivo_id;

            this.dialogRemanejamento = true;

        },
        emitFormRemanejamento(){

            this.dialogRemanejamento = false;
            this.loadingTurma();

        },
        selectAluno(i){

            this.turma.matriculas[i].selected = !this.turma.matriculas[i].selected;
        },

    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.loadingTurma();
                    this.editAluno = true;

                }
            }
        },
        filtroSearch: {
            handler (value) {

                let res = this.alunosForReforco.filter(item => {

                    return item.nome.toLowerCase()
                    .indexOf(value.toLowerCase()) > -1;

                });

                this.alunosForReforcoFilter = res;
            }
        },
    },
    components:{ formRemanejamento, dossieAluno }
}
</script>
<style>

    .search-alunos-reforco .el-input__inner{
        border-radius: initial;
    }

    .titulo-list-instituicoes {
        background-color: #35647F;
        color: #fff;
        padding: 5px 10px;
    }

    .list-alunos-reforco{
        margin: 10px 0px;
    }

    .list-alunos-reforco .checkbox-list{
        padding-left: 20px;
    }

    .list-alunos-reforco ul {
        padding: 0;
        height: 700px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .list-alunos-reforco li {
        padding: 5px 0;
        border-bottom: 1px solid #ccc;
    }

    .list-alunos-reforco{
        border: 1px solid #ccc;
    }

    .info-turma dt{
        width: 170px !important;
    }

    .titulo-list-alunos {
        background-color: #ccc; padding: 5px 10px;
    }

    .list-alunos .checkbox-list{
        margin-left: 20px;
    }

    .list-alunos ul {
        padding: 0;
        height: 700px;
        overflow: auto;
    }

    .list-alunos li {
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
    }

    .list-alunos{
        border: 1px solid #ccc;
    }

</style>